import { Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getOwnChildBranches } from '../../../store/reports/reports_action'
import Datepicker from '../../common/datePicker'
import DropDownOA from '../../common/dropDownOA'
import { appendToUrl, focusElemnt, isEmpty, removeByIndex } from '../../common/helper'
import { Item } from '../../common/snippets'
import { SplitButton } from '../../common/SplitButton'
import * as sx from '../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../common/svg/refresh'
import { ReportHeading } from './common/ReportHeading'
import * as id from './reportId'
import * as lb from './reportLables'
import * as urls from './oldReportsUrls'
import moment from 'moment/moment'
const DailyBranchCollection = (props) => {
  const {
    data: { common, reports },
    getOwnChildBranches,
  } = props
  const { loginData } = common
  const { ownChildBranches } = reports
  const reportName = 'Daily Branch Collection'
  const [selCompany, setSelCompany] = useState(false)
  const [selBranch, setSelBranch] = useState()
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [summary, checkSummary] = useState(0)

  useEffect(() => {
    if (!isEmpty(loginData)) {
      const branchData = {
        intUserID: loginData?.intUserID,
        intCompanyID: loginData?.intCompanyID,
        intIsActive: -1,
      }
      getOwnChildBranches(branchData)
      setSelBranch({ BranchName: loginData.strBranchName, BranchID: loginData.intBranchID })
    }
  }, [loginData])
  const handleClick1 = () => {
    let url = urls.dailyBranchCollection
    const urlData = urls.dailyBranchCollectionParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intCompanyId = loginData.intCompanyID
    urlData.FromDate = fromDate.format('YYYY-MM-DD')
    urlData.ToDate = toDate.format('YYYY-MM-DD')
    urlData.BranchId = selBranch.BranchID
    urlData.Summary = summary ? 1 : 0 
    urlData.BranchName = selBranch.BranchName
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }

  return (
    <Item sx={{ padding: '0' }} className="reports">
      <ReportHeading reportName={reportName} />
      <Box sx={sx.reportFlex}>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            id={id.selectCompnay}
            label={lb.select_company}
            defaultvalue={loginData.strCompanyName}
            disabled={true}
            onSelect={(val) => setSelCompany(val)}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} id={id.goButton} className="btn btn-primary">
            GO
          </Button>
        </Item>
        <Item sx={sx.itemsxGrow}>
          <DropDownOA
            label={lb.select_branch}
            id={id.selBranch}
            data={ownChildBranches || []}
            defaultvalue={loginData.strBranchName}
            dataKey={`BranchName`}
            idKey={`BranchID`}
            onSelect={(val) => setSelBranch(val)}
            width="100%"
            nextId={id.fromDate}
          />
        </Item>
        <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
          <Datepicker
            name={'from_collection_date'}
            label={lb.from_collection_date}
            id={id.fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width="100%"
          />
        </Item>
        <Item sx={sx.itemsxGrow} className="input--container bookingDatePicker">
          <Datepicker
            label={lb.to_collection_date}
            id={id.toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt(id.summaryCheck)
            }}
            width="100%"
          />
        </Item>
        <FormControlLabel
          value="end"
          control={<Checkbox id={id.summaryCheck} />}
          className={`${summary ? 'selcheck' : 'unselcheck'}`}
          label={lb.summary}
          labelPlacement="end"
          checked={summary}
          onChange={() => {
            checkSummary(!summary)
            focusElemnt(id.reportmainButton)
          }}
        />
        <Item sx={sx.itemsx}>
          <SplitButton
            options={['GENERATE OLD FORMAT', 'GENERATE NEW FORMAT']}
            hideToggle={true}
            id1={id.reportmainButton}
            prevID={id.summaryCheck}
            onClick1={handleClick1}
          />
        </Item>
        <Item sx={{ ...sx.itemsx, display: 'none' }}>
          <RefreshSvg />
        </Item>
      </Box>
    </Item>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { getOwnChildBranches }
export default connect(mapStateToProps, mapDispatchToProps)(DailyBranchCollection)
